import {NavigationPathKey, TranslationKey} from '@enums'
import contractsCardImage from '@images/contracts-card.jpg'
import logsCardImage from '@images/logs-card.jpg'
import parentCompaniesCardImage from '@images/parent-companies-card.jpg'
import productsDashboardCardImage from '@images/products-dashboard-card.jpg'
import {Stack, useMediaQuery, useTheme} from '@mui/material'
import {pageLinksAtom} from '@state'

import {useEffect} from 'react'

import {useSetAtom} from 'jotai'
import {useTranslation} from 'react-i18next'

import {ComposedComponents} from '@components'

/**
 * Administration Panel Dashboard page with navigation cards
 */
export function AdminDashboardPage() {
  const {t} = useTranslation()
  const setTitleLinks = useSetAtom(pageLinksAtom)
  useEffect(() => {
    setTitleLinks([{title: t('Admin panel')}])
  }, [setTitleLinks, t])

  const theme = useTheme()
  const isDownLg = useMediaQuery(theme.breakpoints.down('lg'))

  const navigationCardItems: ComposedComponents.CardItem[] = [
    {
      title: t(TranslationKey.Resources),
      key: NavigationPathKey.RESOURCES_DASHBOARD,
      image: parentCompaniesCardImage,
    },
    {
      title: t(TranslationKey.Contracts),
      key: NavigationPathKey.CONTRACT_DASHBOARD,
      image: contractsCardImage,
    },
    {
      title: t(TranslationKey.Products),
      key: NavigationPathKey.PRODUCT_DASHBOARD,
      image: productsDashboardCardImage,
    },
    {
      title: t(TranslationKey.Logs),
      key: NavigationPathKey.LOGS,
      image: logsCardImage,
    },
  ]

  return (
    <Stack gap={5}>
      <ComposedComponents.NavigationCards itemsInRow={isDownLg ? 1 : 2} items={navigationCardItems} />
    </Stack>
  )
}
